import React, { useState, useEffect } from 'react';
import useFetch from '../../../../components/hooks/useFetch';
import {
  PESQUISAR_SISTEMAS_GRUPOS,
  PESQUISAR_SISTEMAS_GRUPOS_SUPERVISOR,
  PERMISSIONARIO_EDITAR_SISTEMAS,
  PERMISSIONARIO_INCLUIR_SISTEMAS,
} from '../../../../services/delegacaoAcesso';
import Input from '../../../../components/form/Input';
import { useForm } from 'react-hook-form';
import ModalDetalhesSistema from './ModalDetalhesSistema';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';

function FormSistemas({
  acaoCancelar,
  dadosEmpresa,
  dadosPerfil,
  listaUsuarios,
  ipAddress,
  incluir,
  dadosGruposCadastrados,
}) {
  const methods = useForm({});
  const { request: requestSistemas, data: dadosSistemas } = useFetch();
  const [sistemaMarcado, setSistemaMarcado] = useState(dadosSistemas);
  const [sistemaExibir, setSistemaExibir] = useState();
  const [modalAbertoDetelheSistema, setModalAbertoDetelheSistema] =
    useState(false);
  const [carregouSistema, setCarregouSistema] = useState(false);
  const [podeSalvar, setPodeSalvar] = useState(true);
  const [sistemasOriginais, setSistemasOriginais] = useState(null);
  const { request } = useFetch();
  const abreModalDetelheSistema = (item) => {
    setSistemaExibir(item);
    setModalAbertoDetelheSistema(true);
  };

  const fechar = () => {
    setModalAbertoDetelheSistema(false);
  };

  const filtrarSistemas = (sistemas) => {
    return sistemas
      .map((sistema) => ({
        ...sistema,
        grupos: sistema.grupos?.filter((grupo) => grupo.marcado),
      }))
      .filter((sistema) => sistema.grupos?.length > 0);
  };

  const possuiAlteracaoNaSistemas = () => {
    if (sistemasOriginais === null) return true;

    const compararValores = (a, b) =>
      String(a).localeCompare(String(b), 'pt-BR', {
        numeric: true,
        sensitivity: 'base',
      });

    const ordenarIdsGrupos = (grupos = []) =>
      grupos.map((grupo) => grupo.idGrupo).sort(compararValores).join(',');

    const serializarSistema = (sistema) =>
      `${sistema.id}|${ordenarIdsGrupos(sistema.grupos)}`;

    const normalizar = (lista) =>
      filtrarSistemas(lista)
        .map(serializarSistema)
        .sort(compararValores)
        .join(';');

    return normalizar(sistemaMarcado) !== normalizar(sistemasOriginais);
  };

  const salvar = async () => {
    if (!possuiAlteracaoNaSistemas()) {
      abreAlertaDialog('Não houve alterações na lista de sistemas.');
      return;
    }
    const sistemasSelecionados = filtrarSistemas(sistemaMarcado);
    const sistemas = sistemasSelecionados.map((item) => ({
      id: item.id,
      grupos: item.grupos.map((g) => ({ idGrupo: g.idGrupo })),
    }));
    let dadosEnviar = {
      listaUsuarios: listaUsuarios,
      listaSistemas: sistemas,
      idCorreiosPF: dadosPerfil?.idCorreiosPF,
      perfil: dadosPerfil?.perfil,
    };
    if (incluir) {
      const { response } = await request(
        PERMISSIONARIO_INCLUIR_SISTEMAS(
          dadosEmpresa.idCorreios,
          dadosEnviar,
          ipAddress,
        ),
      );
      if (response.ok) {
        setSistemasOriginais(sistemaMarcado);
        abreAlertaDialog('Sistema(s) incluído com sucesso!');
      }
    } else {
      const { response } = await request(
        PERMISSIONARIO_EDITAR_SISTEMAS(
          dadosEmpresa.idCorreios,
          dadosEnviar,
          ipAddress,
        ),
      );
      if (response.ok) {
        setSistemasOriginais(sistemaMarcado);
        abreAlertaDialog('Sistema(s) alterado(s) com sucesso!');
      }
    }

    acaoCancelar();
  };

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  useEffect(() => {
    if (dadosSistemas) {
      setSistemaMarcado(dadosSistemas);
      setCarregouSistema(true);
    }
    if (dadosSistemas?.length > 0) {
      setPodeSalvar(true);
    } else {
      setPodeSalvar(false);
    }
  }, [dadosSistemas]);

  useEffect(() => {
    if (carregouSistema && dadosSistemas) {
      const atualizarMarcados = (sistemaMarcado, dadosGruposCadastrados) => {
        return sistemaMarcado.map((sistema) => ({
          ...sistema,
          grupos: sistema.grupos?.map((grupo) => ({
            ...grupo,
            marcado: dadosGruposCadastrados?.some(
              (gc) =>
                gc.idGrupo === grupo.idGrupo && gc.idSistema === sistema.id,
            ),
          })),
        }));
      };

      const novoEstado = atualizarMarcados(sistemaMarcado, dadosGruposCadastrados);
      setSistemaMarcado(novoEstado);
      setSistemasOriginais(novoEstado);
      setCarregouSistema(false);
    }
  }, [carregouSistema]);

  useEffect(() => {
    if (dadosPerfil?.perfil == 'Supervisor') {
      requestSistemas(
        PESQUISAR_SISTEMAS_GRUPOS_SUPERVISOR(
          dadosPerfil.idCorreios,
          dadosPerfil.idCorreiosPF,
        ),
      );
    } else {
      requestSistemas(PESQUISAR_SISTEMAS_GRUPOS(dadosEmpresa.idCorreios));
    }
  }, [dadosEmpresa]);
  const handleCheckBoxSistemaChange = (systemId) => {
    const newData = sistemaMarcado?.map((system) => {
      if (system.id === systemId) {
        const newChecked = !system.marcado;
        return {
          ...system,
          marcado: newChecked,
          grupos: system.grupos?.map((grupo) => ({
            ...grupo,
            marcado: newChecked,
          })),
        };
      }
      return system;
    });
    setSistemaMarcado(newData);
  };

  const handleCheckBoxGrupoChange = (systemId, groupId) => {
    const newData = sistemaMarcado?.map((system) => {
      if (system.id === systemId) {
        return {
          ...system,
          grupos: system.grupos.map((grupo) => {
            if (grupo.idGrupo === groupId) {
              return { ...grupo, marcado: !grupo.marcado };
            }
            return grupo;
          }),
        };
      }
      return system;
    });
    setSistemaMarcado(newData);
  };

  return (
    <>
      <p>
        Ao selecionar os sistemas, não esqueça de{' '}
        <b>salvar ao final da tela.</b>
      </p>

      {sistemaMarcado?.length !== 0 ? (
        <>
          {sistemaMarcado?.map((item, index) => (
            <div className="sistema-card bg-superficie">
              <div className="titulo-sistema">
                <label className="input-checkbox">
                  <Input
                    type="checkbox"
                    name={item.id}
                    id={item.id}
                    onChange={() => handleCheckBoxSistemaChange(item.id)}
                    checked={item.marcado || false}
                    {...formMethods}
                  />
                  <h6>{item.iprojTi?.nome}</h6>
                </label>

                <button
                  title="informação do sistema"
                  className="btn-txt so-icone btn-info"
                  onClick={() => abreModalDetelheSistema(item)}
                >
                  <i className="ic-duvida-circulo"></i>
                </button>
              </div>

              <div className="checkbox-container">
                {item.grupos?.map((grupo, index) => (
                  <label className="input-checkbox">
                    <Input
                      type="checkbox"
                      name={grupo.idGrupo}
                      id={grupo.idGrupo}
                      onChange={() =>
                        handleCheckBoxGrupoChange(item.id, grupo.idGrupo)
                      }
                      checked={grupo.marcado || false}
                      {...formMethods}
                    />
                    {grupo.nome}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </>
      ) : (
        <h6>Não há sistemas habilitados para o CNPJ informado.</h6>
      )}

      <div className="btns-row btns-row-fixo">
        <button
          className="btn-pre"
          onClick={() => salvar()}
          disabled={!podeSalvar}
        >
          Salvar
        </button>
        <button className="btn-txt" onClick={acaoCancelar}>
          Cancelar
        </button>
      </div>

      <ModalDialog
        //titulo={sistemaSelecionado.iprojTi.nome}
        id="modal-DetelheSistema"
        aberto={modalAbertoDetelheSistema}
        setAberto={setModalAbertoDetelheSistema}
        opcaoFechar={true}
      >
        <ModalDetalhesSistema
          acaoCancelar={() => setModalAbertoDetelheSistema(false)}
          acaoFechar={fechar}
          sistemaSelecionado={sistemaExibir}
        />
      </ModalDialog>
    </>
  );
}
export default FormSistemas;
